import moment from 'moment'

const getTimeZoneName = () => {
    const name = window.Intl?.DateTimeFormat()
        .resolvedOptions()
        .timeZone?.split('/')
        .pop()
        .replace(/_/gi, ' ')

    return `${name || 'your'} time`
}

const formatTime = date => {
    return `${new Date(date).toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
    })} (${getTimeZoneName()})`
}

const formatDateTime = date => `${moment(date).format('ddd MMM DD')} • ${formatTime(date)}`

const getFormattedUTCTime = time => moment(time).toISOString()

export { formatTime, formatDateTime, getFormattedUTCTime }
